import React, { Component } from 'react';
import { connect } from 'react-redux';
import { NavBar, DataTables, BreadCumb, TimeOut } from '../../components';
import { DISPATCH_ID, SERVICE_RESPONSE } from '../../libs/utils/Const';
import { ApiClient } from '../../libs/apiClient';
import config from '../../config';

let apiClient = ApiClient.getInstance();

const headersDataTable = [
    { title: "Código", value: true },
    { title: "Nombre", value: true },
    { title: "Email", value: true },
    { title: "Tipo usuario", value: true },
    { title: "", value: false },
    { title: "", value: false },
    { title: "", value: false },
];

class R2D2 extends Component {
    constructor(props) {
        super(props);

        this.state = {

        }
    }

    componentDidMount = async () => {

    }



    render() {


        return (
            <div className="content">
                <NavBar props={this.props} />
                <TimeOut />
                <BreadCumb subitem1={'ADMINISTRACIÓN DE USUARIOS'} url1={'#'} />
                <div style={{ marginLeft: "4rem", marginBottom: "12rem" }}>
                    <h2 className="md-display-1">
                        <a href=" " id="liAdminUsers" className="text-muted">
                            &nbsp;ADMINISTRACIÓN DE PROCESOS R2D2
                        </a>
                    </h2>

                </div>
            </div>
        );
    }
}

const mapStateToProps = store => {
    return { notificationReducer: store.NotificationReducer };
};

const mapDispatchToProps = dispatch => {
    return {
        enableSpinner: value => dispatch({ type: DISPATCH_ID.CONFIG_SET_SPINNER, value })
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(R2D2);
